import React from "react"

import DefaultLayout from "../layouts/default"
import TwoThirdsGrid from "../components/layout/TwoThirdsGrid"
import Text from "../components/text/Text"
import HeadlineWithSub from "../components/text/HeadlineWithSub"
import DottedLineHorizontal from "../components/DottedLineHorizontal"

const active = {
  title: "Coaching"
}

const Coaching = () =>
<DefaultLayout image="/assets/images/IMG_7048.PNG" active={active}>
  <TwoThirdsGrid textRight>

    <div>
      <HeadlineWithSub>
        <h1>Supervision & Coaching</h1>
        <h4>
          Vertrauen, Handlungsraum, Klarheit, Entwicklung
        </h4>
      </HeadlineWithSub>
    </div>
    <Text>
      <div>
        <h4>Kunstorientierte Supervision</h4>
        <p>Supervision mit gestalterischen Mitteln für Kunsttherapeut:innen und <span style={{wordBreak: "keep-all"}}>(Heil-)Pädagog:innen</span>. Im dialogischen Prozess können ausgewählte gestalterische Methoden dazu beitragen, berufliche Fragestellungen aus neuen Perspektiven zu betrachten und das eigene professionelle Handeln zu reflektieren. </p>
      </div>
      <div>
        <h4>Coaching</h4> 
        <p>Coaching in persönlichen Krisen, an Übergängen und Wendepunkten des Lebens. Ein geschützter Raum für Reflexion, Orientierung und neue Perspektiven.</p>
      </div>
      <div>
        <h4>Denkzeit</h4>
        <p>Ein halber oder ganzer Tag für Klärung, Orientierung und anstehende Entscheidungen. Im Gehen und im Gespräch entsteht Raum, um Abstand zu gewinnen, Zusammenhänge zu erkennen und den nächsten Schritt zu entwickeln.</p>
      </div>

      <p>
        Ort und Rahmen werden dem Anliegen entsprechend gemeinsam vereinbart. <br />
        Online, inhouse oder bei einem Spaziergang.
      </p>

      <DottedLineHorizontal />
      <div>
        <p id="StresscoachingFurEltern">Für Fragen und individuell zugeschnittene Angebote: Fragen sie mich an! <br/>
          <a href="mailto:info@strich.sg">info@strich.sg</a> oder <a href="tel:079 844 04 07">079 844 04 07</a>
        </p>
      </div>
    </Text>
  </TwoThirdsGrid>
</DefaultLayout>

export default Coaching